import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnalyticsService } from '../services/analytics.service';

const Navigation: React.FC = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    // Analytics singleton instance
    const analytics = AnalyticsService.getInstance();

    // Check if route is active
    const isActive = (path: string) => location.pathname === path;

    // Toggle menu and track event
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        analytics.event('Navigation', 'toggle_menu', isMenuOpen ? 'close' : 'open');
    };

    // Close menu and track navigation
    const handleNavigation = (path: string) => {
        setIsMenuOpen(false);
        analytics.event('Navigation', 'click', path);
    };

    return (
        <div className="nav-container">
            <div className="logo-item">
                <Link
                    className="nav-link"
                    to="/"
                    onClick={() => handleNavigation('home')}
                >
                    Ольга Гальперина
                </Link>
            </div>
            <button
                className={`hamburger ${isMenuOpen ? 'open' : ''}`}
                onClick={toggleMenu}
                aria-label="Меню"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
                <ul className="nav-list">
                    <li>
                        <Link
                            className={`nav-link ${isActive('/') ? 'active' : ''}`}
                            to="/"
                            onClick={() => handleNavigation('home')}
                        >
                            Главная
                        </Link>
                    </li>
                    <div className="divider-nav"></div>
                    <li>
                        <Link
                            className={`nav-link ${isActive('/about') ? 'active' : ''}`}
                            to="/about"
                            onClick={() => handleNavigation('about')}
                        >
                            Обо мне
                        </Link>
                    </li>
                    <div className="divider-nav"></div>
                    <li>
                        <Link
                            className={`nav-link ${isActive('/services') ? 'active' : ''}`}
                            to="/services"
                            onClick={() => handleNavigation('services')}
                        >
                            Услуги
                        </Link>
                    </li>
                    <div className="divider-nav"></div>
                    <li>
                        <Link
                            className={`nav-link ${isActive('/materials') ? 'active' : ''}`}
                            to="/materials"
                            onClick={() => handleNavigation('materials')}
                        >
                            Полезные материалы
                        </Link>
                    </li>
                    <div className="divider-nav"></div>
                    <li>
                        <Link
                            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                            to="/contact"
                            onClick={() => handleNavigation('contact')}
                        >
                            Запись на консультацию
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Navigation;
